export const apisHeaders = {
  headers: { "Content-Type": "application/json" },
};

export const apisFileHeaders = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};

export const getAuthToken = () => {
  const token = localStorage.getItem("token");
  return token;
};

export const removeAuthToken = () => {
  localStorage.removeItem("token");
};

export const normalizeNumber = (input) => {
  if (!input) return input;
  const hindi = "०१२३४५६७८९";
  const gujarati = "૦૧૨૩૪૫૬૭૮૯";
  let output = "";
  for (let ch of input) {
    if (hindi.includes(ch)) {
      output += hindi.indexOf(ch);
    } else if (gujarati.includes(ch)) {
      output += gujarati.indexOf(ch);
    } else if (ch >= "0" && ch <= "9") {
      output += ch;
    }
  }
  return output;
};